import React, { ChangeEvent, useEffect, useState } from "react";
import { InputAdornment, TextField, useTheme } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";

interface Props {
  label: string;
  handleChange: (value: string) => void;
  value?: string;
}

const Search: React.FC<Props> = (props) => {
  const { label, handleChange, value } = props;
  const theme = useTheme();
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (value === "") {
      setSearch(value);
    }
  }, [value]);

  const handleSearch = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    handleChange(e.target.value);
    setSearch(e.target.value);
  };

  return (
    <TextField
      autoComplete="off"
      size={"medium"}
      variant={"outlined"}
      inputProps={{
        "data-form-type": "other",
        "data-lpignore": " true",
      }}
      fullWidth
      InputProps={{
        autoComplete: "off",
        style: {
          color: theme.palette.primary.main,
          background: "transparent",
        },
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      label={label}
      value={search}
      onChange={(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
        handleSearch(e)
      }
    />
  );
};

export default Search;
